'use client';

import { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { handleErrors } from '@/helpers/handle-errors.helper';

const Context = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not logged in
  const [isLoading, setIsLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const response = await fetch('/api/users/me', {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const { user } = await response.json();
      setUser(user ?? null);
    } catch (error) {
      handleErrors(error, { component: 'auth-provider', action: 'refresh user' });
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch('/api/users/me', {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const { user } = await response.json();
        setUser(user ?? null);
      } catch (error) {
        handleErrors(error, { component: 'auth-provider', action: 'fetch current user' });
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <Context.Provider
      value={{
        user,
        setUser,
        isLoading,
        refreshUser,
      }}
    >
      {children}
    </Context.Provider>
  );
};
const useAuth = () => useContext(Context);

export { AuthProvider, useAuth };
